(function() {
    'use strict';

    if (window.__NEDiscountProductBadgeStableV1) return;
    window.__NEDiscountProductBadgeStableV1 = true;

    var scriptConfig = document.currentScript;
    var PDP_PRODUCT_ID = scriptConfig && scriptConfig.dataset.pdpProductId
      ? Number(scriptConfig.dataset.pdpProductId)
      : null;
    var updateTimer = null;
    var updateToken = 0;
    var discountCache = {};
    var pendingDiscounts = {};
    var cacheGeneration = 0;
    var observerTimer = null;

    function normalizeCode(code) {
      return String(code || '').trim().toUpperCase();
    }

    function isPdpPage() {
      return (
        document.body.classList.contains('template-product') ||
        document.body.getAttribute('template') === 'product' ||
        window.location.pathname.indexOf('/products/') !== -1
      );
    }

    function isVisible(element) {
      if (!element) return false;

      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);

      return (
        rect.width > 0 &&
        rect.height > 0 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0'
      );
    }

    function createBadgeElement(isPdp) {
      var badge = document.createElement('div');

      badge.className = 'ne-discount-product-badge';
      badge.setAttribute('data-discount-product-badge', '');

      if (isPdp) {
        badge.setAttribute('data-pdp-discount-product-badge', '');
      }

      badge.innerHTML =
        '<span class="ne-discount-product-badge__text">-' +
          '<span data-percentage-value></span>%' +
        '</span>' +
        '<span class="ne-discount-product-badge__code-label">' +
          'CODE: <span data-code-value></span>' +
        '</span>';

      return badge;
    }

    function getProductCards() {
      return document.querySelectorAll(
        '.collection__products .product-item, ' +
        '.collection__products .product-card, ' +
        '.collection__infinite-container .product-item, ' +
        '.collection__infinite-container .product-card, ' +
        '.featured-collection-slider__product[data-product-id], ' +
        '.product-item-slide[data-product-id]'
      );
    }

    function getProductIdFromContainer(productContainer) {
      if (!productContainer) return null;

      var child = productContainer.querySelector('[data-productId], [data-product-id]');

      return (
        productContainer.getAttribute('data-productId') ||
        productContainer.getAttribute('data-product-id') ||
        (
          child &&
          (
            child.getAttribute('data-productId') ||
            child.getAttribute('data-product-id')
          )
        )
      );
    }

    function getPdpProductId() {
      if (PDP_PRODUCT_ID) return PDP_PRODUCT_ID;

      var productElement = document.querySelector('[data-product-id], [data-productId]');

      if (productElement) {
        return (
          productElement.getAttribute('data-product-id') ||
          productElement.getAttribute('data-productId')
        );
      }

      if (window.meta && window.meta.product && window.meta.product.id) {
        return window.meta.product.id;
      }

      return null;
    }

    function getProductContainer(badgeElement) {
      if (!badgeElement) return null;

      if (badgeElement.hasAttribute('data-pdp-discount-product-badge')) {
        return badgeElement.closest('.product__media-item, .product__media, .product__media-container, .product');
      }

      return (
        badgeElement.closest('.collection__products .product-item') ||
        badgeElement.closest('.collection__products .product-card') ||
        badgeElement.closest('.collection__infinite-container .product-item') ||
        badgeElement.closest('.collection__infinite-container .product-card') ||
        badgeElement.closest('.featured-collection-slider__product[data-product-id]') ||
        badgeElement.closest('.product-item-slide[data-product-id]')
      );
    }

    function getProductId(badgeElement) {
      if (badgeElement && badgeElement.hasAttribute('data-pdp-discount-product-badge')) {
        return getPdpProductId();
      }

      return getProductIdFromContainer(getProductContainer(badgeElement));
    }

    function getActiveDiscountDetails() {
      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.getDetails === 'function'
      ) {
        try {
          var details = window.NE.DiscountTracker.getDetails();

          if (details && details.code) {
            return {
              code: normalizeCode(details.code),
              percentage: Number(details.percentage || 0)
            };
          }
        } catch (e) {}
      }

      try {
        var cached = sessionStorage.getItem('ne_discount_details');

        if (cached) {
          var parsed = JSON.parse(cached);

          if (parsed && parsed.code) {
            return {
              code: normalizeCode(parsed.code),
              percentage: Number(parsed.percentage || 0)
            };
          }
        }
      } catch (e) {}

      try {
        var storedCode = sessionStorage.getItem('ne_discount_code');

        if (storedCode) {
          return {
            code: normalizeCode(storedCode),
            percentage: 0
          };
        }
      } catch (e) {}

      var cookieMatch = document.cookie.match(/(?:^|;\s*)ne_discount_code=([^;]+)/);

      if (cookieMatch && cookieMatch[1]) {
        return {
          code: normalizeCode(decodeURIComponent(cookieMatch[1])),
          percentage: 0
        };
      }

      return null;
    }

    function ensureCardBadges() {
      getProductCards().forEach(function(productCard) {
        if (!productCard) return;

        var productId = getProductIdFromContainer(productCard);
        if (!productId) return;

        if (productCard.querySelector(':scope > [data-discount-product-badge]')) return;
        if (productCard.querySelector('[data-discount-product-badge]')) return;

        var badge = createBadgeElement(false);

        if (window.getComputedStyle(productCard).position === 'static') {
          productCard.style.position = 'relative';
        }

        productCard.insertBefore(badge, productCard.firstChild);
      });
    }

    function getPdpMediaTargets() {
      if (!isPdpPage()) return [];

      var productSection = document.querySelector(
        '[data-section-type="product"][data-is-full-product="true"]'
      );
      var variantSelect = productSection && productSection.querySelector('[data-variant-select]');
      var selectedVariantId = variantSelect && String(variantSelect.value || '');

      var galleryContainers = Array.prototype.slice.call(
        document.querySelectorAll('.product__primary-left .product__media-container')
      ).filter(function(container) {
        return !container.closest('[data-is-quick-view], [data-quick-view-modal], .quick-product--wrap');
      });

      var targets = galleryContainers.map(function(container) {
        var mediaItems = Array.prototype.slice.call(
          container.querySelectorAll('.product__media-item[data-product-media-wrapper]')
        );

        var selectedVariantTarget = mediaItems.find(function(mediaItem) {
          var mediaVariantId = String(mediaItem.getAttribute('data-product-id') || '');

          return (
            selectedVariantId &&
            mediaVariantId === selectedVariantId &&
            !mediaItem.classList.contains('swiper-slide-duplicate')
          );
        });

        if (selectedVariantTarget) return selectedVariantTarget;

        return mediaItems.find(function(mediaItem) {
          return (
            !mediaItem.classList.contains('hidden') &&
            !mediaItem.classList.contains('swiper-slide-duplicate')
          );
        }) || null;
      }).filter(Boolean);

      if (targets.length) return targets;

      var fallback =
        document.querySelector('.product__primary-left .product__media') ||
        document.querySelector('.product__primary-left .product__media-container');

      return fallback ? [fallback] : [];
    }

    function ensurePdpBadges() {
      if (!isPdpPage()) return;

      var targets = getPdpMediaTargets();

      document.querySelectorAll('[data-pdp-discount-product-badge]').forEach(function(badge) {
        if (targets.indexOf(badge.parentElement) === -1) {
          badge.remove();
        }
      });

      targets.forEach(function(target) {
        if (!target) return;
        if (target.querySelector(':scope > [data-pdp-discount-product-badge]')) return;

        var badge = createBadgeElement(true);

        target.classList.add('ne-pdp-discount-badge-anchor');

        if (window.getComputedStyle(target).position === 'static') {
          target.style.position = 'relative';
        }

        target.insertBefore(badge, target.firstChild);
      });
    }

    function hasNormalProductBadge(productContainer, badgeElement) {
      if (!productContainer || !badgeElement) return false;

      var selector =
        '.product_badge_container, ' +
        '.product-badge__wrapper, ' +
        '.product-badge__wrapper-sale, ' +
        '.product-badges, ' +
        '.product-item__badge, ' +
        '[data-badge]';

      var normalBadges = productContainer.querySelectorAll(selector);

      for (var i = 0; i < normalBadges.length; i++) {
        var normalBadge = normalBadges[i];

        if (!normalBadge) continue;
        if (normalBadge === badgeElement) continue;
        if (normalBadge.closest('[data-discount-product-badge]')) continue;
        if (normalBadge.contains(badgeElement)) continue;
        if (badgeElement.contains(normalBadge)) continue;

        var rect = normalBadge.getBoundingClientRect();
        var style = window.getComputedStyle(normalBadge);

        if (rect.width === 0 || rect.height === 0) continue;
        if (style.display === 'none' || style.visibility === 'hidden') continue;

        return true;
      }

      return false;
    }

    function positionBadge(badgeElement) {
      if (!badgeElement) return;

      var productContainer = getProductContainer(badgeElement);
      if (!productContainer) return;

      var isMobile = window.innerWidth <= 766;
      var isPdpBadge = badgeElement.hasAttribute('data-pdp-discount-product-badge');
      var hasOther = hasNormalProductBadge(productContainer, badgeElement);

      var top;
      var left;

      if (isPdpBadge) {
        top = isMobile ? 16 : 24;
        left = isMobile ? 16 : 24;

        if (hasOther) {
          var normalBadges = productContainer.querySelectorAll(
            '.product_badge_container, .product-badge__wrapper, .product-badge__wrapper-sale, ' +
            '.product-badges, .product-item__badge, [data-badge]'
          );

          for (var i = 0; i < normalBadges.length; i++) {
            var normalBadge = normalBadges[i];

            if (
              normalBadge !== badgeElement &&
              !normalBadge.closest('[data-discount-product-badge]') &&
              isVisible(normalBadge)
            ) {
              var rootRect = productContainer.getBoundingClientRect();
              var normalRect = normalBadge.getBoundingClientRect();
              top = Math.round(normalRect.bottom - rootRect.top + 8);
              break;
            }
          }
        }
      } else {
        top = hasOther ? (isMobile ? 45 : 57) : 12;
        left = hasOther ? (isMobile ? 15 : 21) : 12;

        var badgeContainer = productContainer.querySelector('.product_badge_container');

        if (badgeContainer && isVisible(badgeContainer)) {
          var productRect = productContainer.getBoundingClientRect();
          var badgeContainerRect = badgeContainer.getBoundingClientRect();

          top = Math.round(badgeContainerRect.bottom - productRect.top + 8);
          left = Math.round(badgeContainerRect.left - productRect.left);
        }
      }

      badgeElement.style.setProperty('top', top + 'px', 'important');
      badgeElement.style.setProperty('left', left + 'px', 'important');
    }

    function isFirstVisiblePdpBadge(badgeElement) {
      if (!badgeElement.hasAttribute('data-pdp-discount-product-badge')) return true;

      return getPdpMediaTargets().indexOf(badgeElement.parentElement) !== -1;
    }

    function showBadge(badgeElement, percentage, code) {
      if (!badgeElement || !percentage || percentage <= 0 || !isFirstVisiblePdpBadge(badgeElement)) {
        hideBadge(badgeElement, true);
        return;
      }

      var currentSignature = badgeElement.getAttribute('data-ne-badge-signature') || '';
      var nextSignature = normalizeCode(code) + '|' + Math.round(Number(percentage));

      if (currentSignature === nextSignature && badgeElement.classList.contains('is-visible')) {
        return;
      }

      var percentageElement = badgeElement.querySelector('[data-percentage-value]');
      var codeElement = badgeElement.querySelector('[data-code-value]');

      if (percentageElement) {
        percentageElement.textContent = Math.round(Number(percentage));
      }

      if (codeElement) {
        codeElement.textContent = code || '';
      }

      badgeElement.setAttribute('data-ne-badge-signature', nextSignature);
      positionBadge(badgeElement);

      badgeElement.classList.add('is-visible');
    }

    function hideBadge(badgeElement, force) {
      if (!badgeElement) return;

      /*
        Avoid hiding during active apply/update.
        This prevents flicker while async product discount fetch is resolving.
      */
      if (!force && window.__NEDiscountUiUpdating) return;

      badgeElement.classList.remove('is-visible');
      badgeElement.removeAttribute('data-ne-badge-signature');
    }

    function fetchProductDiscount(code, productId) {
      code = normalizeCode(code);
      productId = String(productId || '').trim();

      if (!code || !productId) return Promise.resolve(0);

      var cacheKey = code + ':' + productId;

      if (Object.prototype.hasOwnProperty.call(discountCache, cacheKey)) {
        return Promise.resolve(discountCache[cacheKey]);
      }

      if (pendingDiscounts[cacheKey]) {
        return pendingDiscounts[cacheKey];
      }

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.fetchProductDiscount === 'function'
      ) {
        var generation = cacheGeneration;
        var request = window.NE.DiscountTracker.fetchProductDiscount(code, productId)
          .then(function(percentage) {
            if (generation !== cacheGeneration) return null;
            percentage = Number(percentage || 0);
            discountCache[cacheKey] = percentage;
            return percentage;
          })
          .catch(function() {
            if (generation !== cacheGeneration) return null;
            discountCache[cacheKey] = 0;
            return 0;
          })
          .then(function(percentage) {
            if (pendingDiscounts[cacheKey] === request) {
              delete pendingDiscounts[cacheKey];
            }

            return percentage;
          });

        pendingDiscounts[cacheKey] = request;
        return request;
      }

      return Promise.resolve(0);
    }

    function updateOneBadge(badgeElement, details, token) {
      if (!badgeElement || !details || !details.code) {
        hideBadge(badgeElement);
        return;
      }

      var productId = getProductId(badgeElement);

      if (!productId) {
        hideBadge(badgeElement);
        return;
      }

      var code = normalizeCode(details.code);

      fetchProductDiscount(code, productId).then(function(productPercentage) {
        if (token !== updateToken) return;
        if (productPercentage === null) return;

        productPercentage = Number(productPercentage || 0);

        if (productPercentage > 0) {
          showBadge(badgeElement, productPercentage, code);
        } else {
          hideBadge(badgeElement);
        }
      });
    }

    function updateAllBadges() {
      updateToken += 1;

      var token = updateToken;
      var details = getActiveDiscountDetails();

      ensureCardBadges();
      ensurePdpBadges();

      if (!details || !details.code) {
        document.querySelectorAll('[data-discount-product-badge]').forEach(function(badgeElement) {
          hideBadge(badgeElement, true);
        });
        return;
      }

      document.querySelectorAll('[data-discount-product-badge]').forEach(function(badgeElement) {
        updateOneBadge(badgeElement, details, token);
      });
    }

    function scheduleUpdate(delay, clearCache) {
      if (clearCache) {
        cacheGeneration += 1;
        discountCache = {};
        pendingDiscounts = {};
      }

      window.__NEDiscountUiUpdating = true;

      clearTimeout(updateTimer);

      updateTimer = setTimeout(function() {
        requestAnimationFrame(function() {
          updateAllBadges();

          setTimeout(function() {
            window.__NEDiscountUiUpdating = false;
          }, 500);
        });
      }, typeof delay === 'number' ? delay : 180);
    }

    function initMutationObserver() {
      var observer = new MutationObserver(function(mutations) {
        var shouldUpdate = false;

        mutations.forEach(function(mutation) {
          if (
            mutation.target &&
            mutation.target.closest &&
            mutation.target.closest(
              '[data-discount-product-badge], [data-is-quick-view], [data-quick-view-modal], .quick-product--wrap'
            )
          ) {
            return;
          }

          if (mutation.type === 'attributes') {
            shouldUpdate = true;
            return;
          }

          if (!mutation.addedNodes || !mutation.addedNodes.length) return;

          mutation.addedNodes.forEach(function(node) {
            if (!node || node.nodeType !== 1) return;
            if (
              node.closest &&
              node.closest('[data-is-quick-view], [data-quick-view-modal], .quick-product--wrap')
            ) {
              return;
            }

            if (
              node.matches &&
              (
                node.matches('.product-item') ||
                node.matches('.product-card') ||
                node.matches('.featured-collection-slider__product') ||
                node.matches('.product-item-slide') ||
                node.matches('.product__media-item') ||
                node.matches('.product__media-container')
              )
            ) {
              shouldUpdate = true;
            }

            if (
              node.querySelector &&
              node.querySelector('.product-item, .product-card, .featured-collection-slider__product, .product-item-slide, .product__media-item, .product__media-container')
            ) {
              shouldUpdate = true;
            }
          });
        });

        if (!shouldUpdate) return;

        clearTimeout(observerTimer);

        observerTimer = setTimeout(function() {
          scheduleUpdate(120, false);
        }, 250);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-hidden', 'data-product-id']
      });
    }

    function init() {
      scheduleUpdate(250, false);

      window.addEventListener('resize', function() {
        scheduleUpdate(180, false);
      });

      window.addEventListener('ne:discount-code-updated', function() {
        scheduleUpdate(280, true);
      });

      window.addEventListener('ne:discount-details-updated', function() {
        scheduleUpdate(280, true);
      });

      window.addEventListener('ne:discount-applied-to-cart', function() {
        scheduleUpdate(280, true);
      });

      document.addEventListener('discount:updated', function() {
        scheduleUpdate(280, true);
      });

      window.addEventListener('ne:discount-code-cleared', function() {
        cacheGeneration += 1;
        discountCache = {};
        pendingDiscounts = {};
        updateToken += 1;
        document.querySelectorAll('[data-discount-product-badge]').forEach(function(badgeElement) {
          hideBadge(badgeElement, true);
        });
      });

      document.addEventListener('theme:pagination:loaded', function() {
        scheduleUpdate(250, false);
      });

      document.addEventListener('shopify:section:load', function() {
        scheduleUpdate(250, false);
      });

      ['variant:change', 'product:variant-change'].forEach(function(eventName) {
        window.addEventListener(eventName, function() {
          scheduleUpdate(120, false);
        });
        document.addEventListener(eventName, function() {
          scheduleUpdate(120, false);
        });
      });

      initMutationObserver();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
      })();
